import { Alert, Autocomplete, Box, Button, Container, Grid2 as Grid, Icon, Skeleton, TextField } from "@mui/material";
import { checkUserType, debounce, FILE_PATH_URI } from "../../../utils/helper";
import TablePagination from "../../../components/common/TablePagination";
import { Fragment, lazy, Suspense, useEffect, useState } from "react";
import SectionSkeleton from "../../../components/ui/SectionSkeleton";
import ContentCard from "../../../components/common/Content";
import { useDispatch, useSelector } from "react-redux";
import { Link as NavLink } from "react-router-dom";
import Images from "../../../assets/js/Images";
import Icons from "../../../assets/js/Icons";
import { useRef } from "react";

import {
  handleRetrieveBlogCategories,
  handleRetrieveBlogs,
} from "../../../redux/public-slices/blog.slice";


const TopBannerA = lazy(() => import("../../../components/common/TopBannerA"));

function AllBlogs() {
  const dispatch = useDispatch();
  const searchRef = useRef(null);
  const categoryRef = useRef(null);
  const [data, setData] = useState({});
  const [categories, setCategories] = useState([]);
  const { loadings } = useSelector((state) => state.otherSlice);
  const userType = checkUserType();

  const handleGetAll = (filters) => {
    dispatch(
      handleRetrieveBlogCategories({
        limit: filters?.limit || 100,
      })
    )
      .unwrap()
      .then((data) => {
        setCategories(data?.records);
      })
      .catch(() => { });
  };

  const handleRetrieveAll = async (filters) => {
    const response = await dispatch(
      handleRetrieveBlogs({
        limit: 10,
        currentPage: filters?.currentPage || null,
        search: searchRef?.current?.value || null,
        categoryId: categoryRef?.current?._id || null,
      })
    ).unwrap();
    setData(response);
  };

  const handleSearch = debounce(() => {
    handleRetrieveAll();
  }, 1000);

  useEffect(() => {
    handleGetAll();
    handleRetrieveAll();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          heading="Blogs"
          currentPage="Blogs"
          bannerImg={Images?.blogs}
        />
      </Suspense>

      <Box sx={{ py: { xs: 5, lg: 10 }, bgcolor: "#f1f1f1" }}>
        <Container maxWidth={false} fixed>
          {userType === "specialist" && (
            <Button
              size="small"
              color="primary"
              variant="contained"
              sx={{
                my: 1,

                color: "white",
              }}
              LinkComponent={NavLink}
              to={`/specialist/profile/add-blog`}
            >
              <Icons.PlusSolid />
              Add Blog
            </Button>
          )}
          <Grid container spacing={2} justifyContent="space-between" mb={5}>
            <Grid size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}>
              <Autocomplete
                size="small"
                id="categories"
                options={categories || []}
                onChange={(_, value) => {
                  setTimeout(() => {
                    categoryRef.current = value;
                    handleRetrieveAll();
                  }, 0);
                }}
                getOptionKey={(option) => option?._id}
                getOptionLabel={(option) => option?.name || ""}
                renderInput={(params) => (
                  <TextField
                    placeholder="Select Category"
                    {...params}
                    sx={{
                      "& .MuiInputBase-input::placeholder": {
                        color: "color !important",
                        opacity: 1,
                      },
                      "& .MuiInputBase-input": {
                        color: "black",
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}>
              <TextField
                size="small"
                type="search"
                inputRef={searchRef}
                onChange={handleSearch}
                sx={{
                  width: "100%",
                  "& .MuiInputBase-input::placeholder": {
                    color: "black !important",
                    opacity: 1,
                  },
                  "& .MuiInputBase-input": {
                    color: "black",
                  },
                }}
                placeholder="Search Blogs"
                slotProps={{
                  input: {
                    startAdornment: (
                      <Icon sx={{ fontSize: "18px", mr: 1, color: "#858585" }}>
                        <Icons.Search />
                      </Icon>
                    ),
                  },
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={5} sx={{ height: "100%" }}>
            {loadings?.retrieveAll ? (
              new Array(4).fill().map((_, i) => (
                <Grid key={i} size={{ xs: 12, md: 6, lg: 4 }}>
                  <Skeleton
                    sx={{
                      width: "100%",
                      transform: "none",
                      aspectRatio: "1/0.5",
                    }}
                  />
                </Grid>
              ))
            ) : data?.records?.length === 0 ? (
              <Grid size={12}>
                <Alert
                  sx={{
                    fontSize: "20px",
                    fontWeight: "500",
                    alignItems: "center",
                    fontFamily: "Poppins",
                    ".MuiAlert-message": { p: "0" },
                    ".MuiAlert-icon": { fontSize: "28px" },
                  }}
                  color="error"
                  severity="error"
                >
                  No Records Found!
                </Alert>
              </Grid>
            ) : (
              data?.records?.map((element, i) => (
                <Grid key={i} size={{ xs: 12, md: 6, lg: 4 }}>
                  <ContentCard
                    type="blog"
                    id={element._id}
                    title={element.title}
                    image={FILE_PATH_URI + (element.banner?.path || element.banner?.source || "")}
                    date={element.createdAt}
                    description={element.description}
                    categoryButtonLink={`/blog-category/${element.category?._id || element.categoryId}`}
                    categoryButtonText={element.category?.name || "Uncategorized"}
                  />
                </Grid>
              ))
            )}
          </Grid>

          <TablePagination
            pagination={data?.pagination}
            length={data?.records?.length}
            loading={loadings?.retrieveAll}
            cb={handleRetrieveAll}
          />
        </Container>
      </Box>
    </Fragment>
  );
}

export default AllBlogs;
